import { render, staticRenderFns } from "./Texti18n.vue?vue&type=template&id=2d1d89b9"
import script from "./Texti18n.vue?vue&type=script&lang=js"
export * from "./Texti18n.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports